import Marionette from 'backbone.marionette';
import Navigator from 'app';
import legislativeDayControlCompositviewTmpl from '../templates/legislative_day_control_compositview.tpl';
import LegislativeDayControlItemview from './legislative_day_control_itemview';
import { Calendar } from '@fullcalendar/core';
//import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import viewportUtils from '../../common/helpers';
import multiMonthPlugin from '@fullcalendar/multimonth';
export default Marionette.CompositeView.extend({
  template: legislativeDayControlCompositviewTmpl,
  childView: LegislativeDayControlItemview,
  childViewContainer: "#days",
  //className: "center",
  events: {

    // "click #events-previous" : "showPreviousDay",
    // "click #events-next"     : "showNextDay"
  },
  getDayModelIndex(day) {
    return day.id - 1;
  },
  initialize: function () {
    let that = this,
      windowHeight = window.innerHeight,
      windowWidth = window.innerWidth;
    let el = this.el,
      legDayLabel = 'Day ',
      aspectRatio = function () {
        if (windowWidth > windowHeight) {
          return window.innerWidth / window.innerHeight * 1.5;
        }
        return 1.5;
      };
    if (windowHeight > 800 && viewportUtils.isEqualOrGreaterThan("sm")) {
      legDayLabel = `Legislative day `;
    }
    ;
    let allSessionDaysArr = that.collection.models.map(obj => {
      let day = obj.attributes.legislative_day;
      // they are 0 based, isNaN and >= will coerce null to 0
      // TODO: do we need this check since we filter later? Or was that just so we could look for last date?
      if (day > 0 || day === 0) {
        return {
          title: `${legDayLabel}${+day + 1}`,
          start: obj.attributes.legislative_day_date,
          allDay: true,
          eventInteractive: true,
          id: obj.attributes.id,
          display: 'background'
        };
      }
      return {};
    });
    let inSessionDaysArr = allSessionDaysArr.map((item, index) => ({
      ...item,
      allDaysIndex: index
    })) // Add allDaysIndex property so we can find these items in allSessionDaysArr
    .filter(item => Object.keys(item).length > 1); // Filter out empty objects

    let latestInSessionDayItem = inSessionDaysArr[inSessionDaysArr.length - 1];
    let latestAllSessionDayItem = allSessionDaysArr[latestInSessionDayItem.allDaysIndex];
    latestAllSessionDayItem.classNames = ["selected-day"];

    // other components will check this view's .index property to find the most recent session date - this is used by journal_controller to load data for the most recent session date in the tabs when the journal page loads
    // FIXME: the way this is set up, only session dates are selectable, so you can only see votes/status changes on session dates. Usually that's when they happen, but sometimes votes go past midnight on Sine Die (and maybe Crossover Day). Statuses continue to change for several days after Sine Die. A previous version of this page and forward and back arrows... we could try making the background color different (and selectable) for dates that are not part of the session but still had event happen on them?
    this.index = that.getDayModelIndex(latestAllSessionDayItem);

    // You can dynamically set a calendar’s height after initialization:
    // calendar.setOption('height', 700);
    // https://fullcalendar.io/docs/height
    this.calendar = new Calendar(el, {
      // height: 200,
      plugins: [multiMonthPlugin, interactionPlugin],
      // for some reason windowResize triggers on eventClick on ajc.com? Which triggers rerender which clears the .selected-day class so you can no longer tell which day you are looking at the data for
      handleWindowResize: false,
      initialView: 'multiMonthYear',
      aspectRatio: aspectRatio(),
      // based on the documentation I think this is supposed to work, but it doesn't
      // validRange: function (){
      //   //start: '2024-01-01',
      //   return { end: '2024-03-31'}
      // },
      multiMonthMaxColumns: 1,
      // force a single column instead of grid of months
      headerToolbar: false,
      // for multiMonthYear this toolbar switches between years
      events: allSessionDaysArr,
      initialDate: latestInSessionDayItem.start,
      eventClick: function (info) {
        let selectedId = that.getDayModelIndex(info.event);
        Navigator.vent.trigger("event:day:change", selectedId);
        // I think index is only referenced when the page first loads but may as well keep it up to date. It used to be used for the forward and back arrows that you could use to navigate the calendar but those are not part of the UI anymore
        that.index = selectedId;
        $(".fc-event.selected-day").removeClass("selected-day");
        $(info.el).addClass("selected-day");
      }
    });
  },
  onShow: function () {
    this.calendar.render();
    //this.calendar.gotoDate( date )

    // $(" .days-list .day-item").removeClass("current_week").removeClass("current_day");
    // const this_week = $(" .days-list .day-item").slice(this.index-4, this.index);
    // this_week.addClass("current_week");
    // $($(" .days-list .day-item")[this.index]).addClass("current_day");
  }

  /* showPreviousDay: function () {
    if (this.index > 0) {
      this.index = this.index - 1;
      Navigator.vent.trigger("event:day:change", this.index);
       // Change display date
      // $(" .days-list .day-item").removeClass("current_week").removeClass("current_day");
  //       const this_week = $(" .days-list .day-item").slice(this.index-4, this.index);
  //       this_week.addClass("current_week");
  //       $($(" .days-list .day-item")[this.index]).addClass("current_day");
    }
  },
   showNextDay: function () {
    if (this.index < this.collection.length - 1) {
      this.index = this.index + 1;
      Navigator.vent.trigger("event:day:change", this.index);
       // $(" .days-list .day-item").removeClass("current_week").removeClass("current_day");
      // const this_week = $(" .days-list .day-item").slice(this.index-4, this.index);
      // this_week.addClass("current_week");
      // $($(" .days-list .day-item")[this.index]).addClass("current_day");
    }
  },*/
});